/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 囤货波次出库拣货 的 **请求配置**
 *
 * @分类 仓储API/波次
 * @请求头 `POST /erp/WavePicking/stockWpOutPicking`
 */
const postStockWpOutPickingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WavePicking/stockWpOutPicking",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postStockWpOutPicking",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 囤货波次出库拣货 的 **请求函数**
 *
 * @分类 仓储API/波次
 * @请求头 `POST /erp/WavePicking/stockWpOutPicking`
 */
export const postStockWpOutPicking = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postStockWpOutPickingRequestConfig, requestData),
    ...args
  );
};
postStockWpOutPicking.requestConfig = postStockWpOutPickingRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 保存波次校验配置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/WavePicking/diffStockoutSettingSave`
 */
const postDiffStockoutSettingSaveRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WavePicking/diffStockoutSettingSave",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postDiffStockoutSettingSave",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 保存波次校验配置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/WavePicking/diffStockoutSettingSave`
 */
export const postDiffStockoutSettingSave = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postDiffStockoutSettingSaveRequestConfig, requestData),
    ...args
  );
};
postDiffStockoutSettingSave.requestConfig =
  postDiffStockoutSettingSaveRequestConfig;
/**
 * 接口 获取波次校验配置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/WavePicking/diffStockoutSettingGet`
 */
const postDiffStockoutSettingGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WavePicking/diffStockoutSettingGet",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postDiffStockoutSettingGet",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取波次校验配置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/WavePicking/diffStockoutSettingGet`
 */
export const postDiffStockoutSettingGet = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postDiffStockoutSettingGetRequestConfig, requestData),
    ...args
  );
};
postDiffStockoutSettingGet.requestConfig =
  postDiffStockoutSettingGetRequestConfig;
/**
 * 接口 分离设置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/WavePicking/onlyDabiaoSetting`
 */
const postOnlyDabiaoSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WavePicking/onlyDabiaoSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postOnlyDabiaoSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 分离设置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/WavePicking/onlyDabiaoSetting`
 */
export const postOnlyDabiaoSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postOnlyDabiaoSettingRequestConfig, requestData),
    ...args
  );
};
postOnlyDabiaoSetting.requestConfig = postOnlyDabiaoSettingRequestConfig;
/**
 * 接口 获取分离设置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/WavePicking/onlyDabiaoSetting`
 */
const getOnlyDabiaoSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WavePicking/onlyDabiaoSetting",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getOnlyDabiaoSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取分离设置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/WavePicking/onlyDabiaoSetting`
 */
export const getOnlyDabiaoSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getOnlyDabiaoSettingRequestConfig, requestData),
    ...args
  );
};
getOnlyDabiaoSetting.requestConfig = getOnlyDabiaoSettingRequestConfig;
/**
 * 接口 波次分播设置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/WavePicking/CutSetting`
 */
const getCutSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WavePicking/CutSetting",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getCutSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 波次分播设置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/WavePicking/CutSetting`
 */
export const getCutSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getCutSettingRequestConfig, requestData), ...args);
};
getCutSetting.requestConfig = getCutSettingRequestConfig;
/**
 * 接口 设置囤货波次自动上架功能开关 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/WavePicking/setStockWavePickingSwitch`
 */
const postSetStockWavePickingSwitchRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WavePicking/setStockWavePickingSwitch",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetStockWavePickingSwitch",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置囤货波次自动上架功能开关 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/WavePicking/setStockWavePickingSwitch`
 */
export const postSetStockWavePickingSwitch = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetStockWavePickingSwitchRequestConfig, requestData),
    ...args
  );
};
postSetStockWavePickingSwitch.requestConfig =
  postSetStockWavePickingSwitchRequestConfig;
/**
 * 接口 获取囤货波次自动上架功能开关 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/WavePicking/getStockWavePickingSwitch`
 */
const getGetStockWavePickingSwitchRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WavePicking/getStockWavePickingSwitch",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetStockWavePickingSwitch",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取囤货波次自动上架功能开关 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/WavePicking/getStockWavePickingSwitch`
 */
export const getGetStockWavePickingSwitch = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getGetStockWavePickingSwitchRequestConfig, requestData),
    ...args
  );
};
getGetStockWavePickingSwitch.requestConfig =
  getGetStockWavePickingSwitchRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/wavePicking.js